import React from 'react';
import { Calendar, Tag, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getImageUrl } from '../../utils/imageUtils.js';

const labels = {
  ne: {
    title: 'समाचार र लेख',
    subtitle: 'यस क्षेत्रका हालका समाचार र अद्यावधिकहरू।',
    readMore: 'थप पढ्नुहोस्',
  },
  en: {
    title: 'News and Articles',
    subtitle: 'Recent news and updates for this sector.',
    readMore: 'Read More',
  },
};

const SectorNews = ({ news, language = 'ne' }) => {
  if (!news || news.length === 0) {
    return null;
  }

  const t = labels[language] || labels.ne;

  return (
    <section className="sector-news">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t.title}</h2>
          <p className="section-subtitle">
            {t.subtitle}
          </p>
        </div>

        <div className="news__grid">
          {news.map((article, index) => {
            const isRealArticle = !!article._id;
            const date = isRealArticle
              ? new Date(article.createdAt).toLocaleDateString('ne-NP', { day: 'numeric', month: 'short', year: 'numeric' })
              : article.date;
            const description = isRealArticle ? article.excerpt : article.description;
            const category = isRealArticle ? article.sector : article.category;

            return (
              <div key={article._id || index} className="news-card">
                {article.imageUrl && (
                  <img src={getImageUrl(article.imageUrl)} alt={article.title} className="news-card__image" style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: '12px 12px 0 0' }} />
                )}
                <div className="news-card__meta">
                  <div className="news-card__date">
                    <Calendar size={14} />
                    <span>{date}</span>
                  </div>
                  <div className="news-card__category">
                    <Tag size={14} />
                    <span>{category}</span>
                  </div>
                </div>
                <h3 className="news-card__title">{article.title}</h3>
                <p className="news-card__description">{description}</p>
                {isRealArticle ? (
                  <Link to={`/news/${article._id}`} className="news-card__link">
                    {t.readMore}
                    <ArrowRight size={14} />
                  </Link>
                ) : (
                  <a href="#" className="news-card__link">
                    {t.readMore}
                    <ArrowRight size={14} />
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SectorNews;
